module.exports = __webpack_public_path__ + "files/de6d7aa73299b8019beac019e5c34a60.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-3.png
// module id = 1367
// module chunks = 59